import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/flows/_list/code')({
  head: () => ({
    meta: [{ title: 'Flow Custom Actions | Tekst' }],
  }),
});
